import { useQuery  } from "react-query";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IDateRange } from "../../common/models/IDateRange";
import { DEFAULT_STALE_TIME } from "../../services/query-client-service/QueryClientService";
import { RestError } from "../../services/rest-service/RestService";
import { TrendConfigurationModel } from "../../services/trending-configuration-data-service/Models";
import { ITrendDataResultsModel, ITrendingDisplayOptions, TrendingDataRequestModel } from "../../services/trending-data-service/Models";
import TrendingDataService from "../../services/trending-data-service/TrendingDataServices";
import { BaseUseQueryParameters, DEFAULT_CACHE_TIME, DEFAULT_KEEP_PREVIOUS_DATA } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectGraphDataQueryParams = {
    contextGroupID: number,
    eLynxObject: IeLynxObject | undefined,
    configuration: TrendConfigurationModel | undefined,
    configurationID: number | undefined,
    duration: IDateRange,
    displayOptions: ITrendingDisplayOptions | undefined,    
} & BaseUseQueryParameters<ITrendDataResultsModel>;

export function useObjectGraphData(params: UseObjectGraphDataQueryParams) {
    return useQuery<ITrendDataResultsModel | undefined, RestError>(

        keys.data(
            params.contextGroupID,
            params.eLynxObject,
            params.configuration,
            params.configurationID,
            params.duration,
            params.displayOptions),
        ({ signal }) => {

            if (params.eLynxObject && (params.configurationID !== undefined || params.configuration !== undefined)) {
                const requestData = new TrendingDataRequestModel({
                    configuration: params.configuration,
                    configurationID: params.configurationID,
                    disableDeferredData: false,
                    displayOptions: params.displayOptions,
                    endTime: params.duration.endDate,
                    startTime: params.duration.startDate,
                    windowHeight: window.outerHeight,
                    windowWidth: window.outerWidth
                });

                return TrendingDataService.getData(params.contextGroupID as number,
                    params.eLynxObject,
                    requestData,
                    signal);
            }
        },
        {
            cacheTime: params.cacheTime ?? DEFAULT_CACHE_TIME,
            enabled: params.enabled,
            keepPreviousData: params.keepPreviousData ?? DEFAULT_KEEP_PREVIOUS_DATA,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: ((data) => data?.refreshEnabled && data?.refreshSeconds
                ? data.refreshSeconds * 1000
                : false),
            //refetchOnWindowFocus: params.refetchOnWindowFocus,
            staleTime: params.staleTime ?? DEFAULT_STALE_TIME,
        }
    );
}
